export const nds = [
  { value: 'none', label: 'Без НДС' },
  { value: 'NDS20', label: '20%' }
]